import React, { ReactNode, useCallback } from 'react';
import styled from 'styled-components';

import SimpleModalOrMobilePage from '#/components/basic/modal/SimpleModalOrMobilePage';
import ScrollableMobileCenteredBox from '#/components/basic/panels/ScrollableMobileCenteredBox';
import HeaderMobile from '#/components/layout/header/HeaderMobile';
import MetaTags from '#/components/layout/header/MetaTags';
import { staticDispatch, useSelector } from '#/reduxState/store';
import { showWalletModal } from '#/reduxState/wallet/walletDetailsReducer';
import { WalletType } from '#/reduxState/wallet/walletUtils';
import { scrollbarStyle } from '#/styleShared';

import { walletsMap } from './walletsListCore';

const Content = styled.div`
  max-width: 700px;
  margin: 0 auto;
`;

const Detail = styled.div`
  min-height: 150px;
  overflow-x: auto;
  ${scrollbarStyle}
`;

const FullScreenWrap = styled.div`
  height: calc(100% - var(--mobileNavHeight));
`;

function UnlockLayout({
  selectedDetail,
  isQrScren,
  onClose,
  closeDisabled,
  children,
  isDetail,
  titleOverride,
  layout,
}: {
  selectedDetail: WalletType | undefined;
  isQrScren: boolean;
  onClose: () => void;
  closeDisabled: boolean;
  children: ReactNode;
  layout: 'page' | 'modal'; // | 'qrScanner';
  titleOverride?: string;
  isDetail?: boolean;
}) {
  const unlocked = !!useSelector(state => state.wallet.walletAddress);
  const isMobile = useSelector(state => state.screen.isMobile);

  const wallet = selectedDetail ? walletsMap[selectedDetail] : undefined;

  const unllockCallback = useCallback(() => {
    staticDispatch(showWalletModal({ show: false }));
  }, []);

  const title =
    titleOverride ||
    (selectedDetail === 'qrSynced' ? 'Scan QR Code' : `Connect Wallet`);

  const childrenWrapped = isDetail ? <Detail>{children}</Detail> : children;

  if (layout === 'modal') {
    return (
      <SimpleModalOrMobilePage
        title={title}
        appearAnimation
        minHeight="280px"
        size="medium"
        onBack={selectedDetail === 'qrSynced' ? onClose : undefined}
        onClose={
          closeDisabled
            ? undefined
            : selectedDetail
            ? undefined
            : unllockCallback
        }
      >
        {isQrScren ? (
          // On this screen we need full height screen, no scroll
          <FullScreenWrap>{childrenWrapped}</FullScreenWrap>
        ) : (
          <ScrollableMobileCenteredBox>
            <div>{childrenWrapped}</div>
          </ScrollableMobileCenteredBox>
        )}
      </SimpleModalOrMobilePage>
    );
  }

  // Unlock Page (used on mobile)
  return (
    <>
      <MetaTags title="Connect Wallet" />

      {isMobile && (
        <HeaderMobile
          backGoTo={closeDisabled || selectedDetail ? undefined : '/'}
          onBackClick={
            closeDisabled ? undefined : selectedDetail ? onClose : undefined
          }
        >
          {wallet?.title || 'Connect Wallet'}
        </HeaderMobile>
      )}
      {!isMobile && (
        <h1 style={{ textAlign: 'center', padding: '25px 0 5px 0' }}>
          {unlocked ? 'Change' : 'Connect'} Wallet
        </h1>
      )}

      <Content>{childrenWrapped}</Content>
    </>
  );
}

export default UnlockLayout;
